import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import CityAreaFilter from '../cityAreaFilter/CityAreaFilter';

const AlertCityArea = ({ cityAreas, onChange, cityAreaIds }) => (
  <Fragment>
    <div className="add-edit-form__grid-label add-edit-form__grid-label--top">
      {trans('search.filter.area')}
    </div>

    <CityAreaFilter
      prefix="alert_modal"
      cityAreas={cityAreas}
      onChange={onChange}
      cityAreaIds={cityAreaIds}
      isAlert
    />
  </Fragment>
);

AlertCityArea.propTypes = {
  cityAreas: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    }).isRequired
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  cityAreaIds: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default AlertCityArea;
